/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import image1 from './images/slide1.jpg';
import image2 from './images/slide2.jpg';
import image3 from './images/slide3.jpg';
import image4 from './images/slide4.jpg';
import image5 from './images/slide5.jpg';
import Login from './Login';
import { motion } from 'framer-motion';

class LoginWrapper extends Component {
  render() {
    const { username, password } = this.props;
    return (
      <div className="login-wrapper">
        <div className="login-main">
          <div className="slideshow">
            <img src={image1} alt="slide1" className="slide1" />
            <motion.img
              animate={{ opacity: [0, 1, 0, 0, 0, 0] }}
              transition={{
                duration: 20,
                ease: 'easeInOut',
                loop: Infinity,
              }}
              src={image2}
              alt="slide2"
              className="slide2"
            />
            <motion.img
              animate={{ opacity: [0, 0, 1, 0, 0, 0] }}
              transition={{
                duration: 20,
                ease: 'easeInOut',
                loop: Infinity,
              }}
              src={image3}
              alt="slide3"
              className="slide3"
            />
            <motion.img
              animate={{ opacity: [0, 0, 0, 1, 0, 0] }}
              transition={{
                duration: 20,
                ease: 'easeInOut',
                loop: Infinity,
              }}
              src={image4}
              alt="slide4"
              className="slide4"
            />
            <motion.img
              animate={{ opacity: [0, 0, 0, 0, 1, 0] }}
              transition={{
                duration: 20,
                ease: 'easeInOut',
                loop: Infinity,
              }}
              src={image5}
              alt="slide5"
              className="slide5"
            />
          </div>
          <div className="login">
            <Login
              username={username}
              password={password}
              handleLogin={this.props.handleLogin}
            />
            <div className="signup">
              <p>
                Don't have an account?
                <a href="#"> Sign up</a>
              </p>
            </div>
            <div className="get-app">
              <p>Get the app.</p>
              <div className="app-links">
                <a href="#">
                  <img
                    src="https://instagram.com/static/images/appstore-install-badges/badge_ios_english-en.png/180ae7a0bcf7.png"
                    alt="app store"
                  />
                </a>
                <a href="#">
                  <img
                    src="https://www.instagram.com/static/images/appstore-install-badges/badge_android_english-en.png/e9cd846dc748.png"
                    alt="google play"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <footer className="login-footer">
          <div className="login-footer-left">
            <div>
              <a href="#">ABOUT</a>
              <a href="#">HELP</a>
              <a href="#">PRESS</a>
              <a href="#">API</a>
              <a href="#">JOBS</a>
              <a href="#">PRIVACY</a>
            </div>
            <div>
              <a href="#">TERMS</a>
              <a href="#">LOCATIONS</a>
              <a href="#">TOP ACCOUNTS</a>
              <a href="#">HASHTAGS</a>
            </div>
            <div>
              <a href="#">LANGUAGE</a>
            </div>
          </div>
          <div className="login-footer-right">
            <p>© 2020 INSTAGRAM FROM FACEBOOK </p>
          </div>
        </footer>
      </div>
    );
  }
}

export default LoginWrapper;
